import { render, staticRenderFns } from "./IcpBeian.vue?vue&type=template&id=28c59f0e&scoped=true"
import script from "./IcpBeian.vue?vue&type=script&lang=js"
export * from "./IcpBeian.vue?vue&type=script&lang=js"
import style0 from "./IcpBeian.vue?vue&type=style&index=0&id=28c59f0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c59f0e",
  null
  
)

export default component.exports